import { render, staticRenderFns } from "./geneltiplist.vue?vue&type=template&id=254fffc3"
import script from "./geneltiplist.vue?vue&type=script&lang=js"
export * from "./geneltiplist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports